import { Grid, Hidden, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import ChangeLanguage from 'components/ChangeLanguage';
import React from 'react';
import { cyrb53Hash } from 'utils/helpers';
import clsx from 'clsx';
import useWindowDimensions from 'hooks/useWindowWidth';
import styles from './styles';

const useStyles = makeStyles(styles);

interface LinkButton {
  name: string;
  url: string;
}

interface LoginPageProps {
  logoHeaderUrl: string;
  logoContentUrl?: string;
  logoMobileUrl?: string;
  backgroundImageUrl: string;
  description?: string;
  links?: LinkButton[];
  children: React.ReactNode;
}

const LoginPage: React.FC<LoginPageProps> = ({
  logoContentUrl,
  backgroundImageUrl,
  logoMobileUrl,
  description,
  links,
  children,
}) => {
  const classes = useStyles();

  const { width } = useWindowDimensions();

  return (
    <Grid container className={classes.root}>
      <Hidden smDown>
        <Grid item className={classes.header}>
          <ChangeLanguage />
        </Grid>
      </Hidden>

      <Grid container className={classes.col}>
        <img
          className={classes.imageBack}
          src={backgroundImageUrl}
          alt="Background"
        />

        <Hidden smDown>
          <Grid container justify="center" className={classes.logoSubtitle}>
            <Grid item className={classes.colContent}>
              {logoContentUrl && (
                <img className={classes.logo} src={logoContentUrl} alt="Logo" />
              )}
              <Typography className={classes.text} variant="body1">
                {description}
              </Typography>
            </Grid>
          </Grid>
        </Hidden>
      </Grid>

      <Grid
        item
        className={clsx(classes.wrapContent, {
          [classes.mobileTop]: width < 960,
        })}
      >
        <Grid item className={classes.content}>
          {logoMobileUrl && (
            <Hidden mdUp>
              <img className={classes.logo} src={logoMobileUrl} alt="Logo" />
            </Hidden>
          )}
          {children}
        </Grid>

        <Hidden smDown>
          <Grid
            container
            item
            xs={12}
            className={classes.copyrightWrapper}
            alignContent="center"
            alignItems="center"
          >
            {links?.map(item => (
              <a
                key={cyrb53Hash(item?.name)}
                href={item?.url}
                target="_blank"
                // eslint-disable-next-line spaced-comment
                rel="noopener noreferrer" //NOSONAR ignoring sonar for this line to open in same tab
                className={classes.link}
              >
                <Typography variant="body1" className={classes.link}>
                  {item?.name}
                </Typography>
              </a>
            ))}

            <Grid item className={classes.copyLogo}>
              <img src="/images/Skyone_logo-01.svg" alt="Logo Sky.One" />
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    </Grid>
  );
};

export default LoginPage;
